import React from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { CssBaseline } from '@mui/material'
import { ApolloProvider } from '@apollo/client'

import { ThemeProvider } from './contexts/ThemeContext'
import { AuthProvider } from './contexts/AuthContext'
import { ToastProvider } from './contexts/ToastContext'

import client from './apolloClient'

import App from './App'
import * as serviceWorker from './serviceWorker'

const container = document.getElementById('root')
const root = createRoot(container)

root.render(
  <BrowserRouter
    future={{
      v7_startTransition: true,
      v7_relativeSplatPath: true,
    }}>
    <ThemeProvider>
      <CssBaseline />
      <AuthProvider>
        <ApolloProvider client={client}>
          <ToastProvider>
            <App />
          </ToastProvider>
        </ApolloProvider>
      </AuthProvider>
    </ThemeProvider>
  </BrowserRouter>
)

// const onUpdate = () => {
//   // eslint-disable-next-line no-alert
//   alert('New version is available, Please close all tab and reload this page.')
// }

// serviceWorker.register({ onUpdate })
serviceWorker.unregister()
